export default __webpack_public_path__ + "static/media/fullLogo.f62b67a3.svg";